import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class SettingsService {
    constructor(private http: HttpClient) {}

    public getPortalSettings(): Observable<any> {
        return this.http.get<any>('/admin/settings/portal');
    }

    public savePortalSettings(data: any): Observable<any> {
        return this.http.post<any>('/admin/settings/portal', data);
    }
}
